import {
  Component,
  Input,
} from '@angular/core';


/**
 * The Global navigation is a region of the graphical user interface reserved for global level actions like
 * app tray bar, search bars, notification or any other design element affording movement from one set of content to another.
 */
@Component({
  selector: 'clo-global-menu',
  templateUrl: './global-menu.html',
  styleUrls: ['./global-menu.css']
})
export class CloGlobalMenu {

  /**
   * URL to the logo image
   */
  @Input() icon: string;

  @Input() productName: string;

  @Input() hasProfile = true;
  constructor() { }

}
